import {
  IssueFragment,
  PartialObservationsV1IssueInput,
  UpdateIssueMutation,
  useUpdateIssueMutation,
  withStandardUpdateHook,
} from '@spotify/confidence-graphql';

export const useUpdateIssue = withStandardUpdateHook<
  UpdateIssueMutation,
  IssueFragment,
  'updateIssue',
  PartialObservationsV1IssueInput
>(useUpdateIssueMutation, 'updateIssue');
